module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rightContent"
  }, [_c('div', {
    staticClass: "msg-tip"
  }, [_vm._v("注意：训练的体验时长只有30秒，无法达到训练效果。如需正常训练，请在档案页面选择患者进行现场训练。")]), _vm._v(" "), _c('trainMenu', {
    ref: "trainmenu",
    attrs: {
      "trainCategories": _vm.trainCategories,
      "isModal": _vm.isModal
    },
    on: {
      "trainmenuEvent": _vm.trainFun,
      "category-path-updated": _vm.onTrainCategoryChoose
    }
  }), _vm._v(" "), _c(_vm.currentView, {
    ref: "traincontent",
    tag: "component",
    attrs: {
      "noTrain": _vm.noTrain,
      "trainCategories": _vm.trainCategories,
      "trainList": _vm.currentTrainCategory ? _vm.sortGame(_vm.currentTrainCategory.games) : []
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-697ba05a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/train.vue
// module id = 1001
// module chunks = 2